import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { DateRangeFilterLabel } from "./DateRangeFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskCompletedOnFilterLabel: React.FC<Props> = ({ filters }) => {
    const { taskCompletedAtStart, taskCompletedAtEnd } = filters;

    return (
        <DateRangeFilterLabel
            start={taskCompletedAtStart}
            end={taskCompletedAtEnd}
        />
    );
};
